import React from "react";

const knownBugs = () => {
  return (
    <div>
      <h2>Known Bugs</h2>
      <hr />
      <p>No bugs known</p>
    </div>
  );
};

export default knownBugs;
